import { useAuth, useCurrentAccount } from "../../../hooks";
export var useIsTierUpdated = function() {
    var accountId = useAuth().accountId;
    var tier = useCurrentAccount().tier;
    var nextTierId = localStorage.getItem("vch.next_tier_".concat(accountId));
    var hasAnnouncement = false;
    if (nextTierId && nextTierId === (tier === null || tier === void 0 ? void 0 : tier.id)) {
        hasAnnouncement = true;
    }
    return {
        hasAnnouncement: hasAnnouncement,
        isAcknowledged: false,
        setAcknowledged: function() {
            localStorage.removeItem("vch.next_tier_".concat(accountId));
        }
    };
};

//# sourceMappingURL=useIsTierUpdated.js.map